import { Sun, Award, Footprints, Waves } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

const BEACH_IMAGE = "/assets/images/chahue-beach.webp";
const MARINA_IMAGE = "/assets/images/marina-chahue.webp";
const HUATULCO_BEACH = "/assets/images/huatulco-beach.webp";
const SANTA_CRUZ = "/assets/images/santa-cruz-beach.webp";

const images = [
  { src: BEACH_IMAGE, alt: "Playa Chahué aerial view" },
  { src: MARINA_IMAGE, alt: "Marina Chahué" },
  { src: HUATULCO_BEACH, alt: "Huatulco Beach" },
  { src: SANTA_CRUZ, alt: "Santa Cruz Beach" },
];

const icons = [Sun, Award, Footprints, Waves];

const PlayaChahueSection = () => {
  const { t } = useLanguage();

  return (
    <section className="bg-white" data-testid="playa-chahue-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-[#B5613B] font-accent mb-4 block">{t.playaChahue.label}</span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-[#2D2926] mb-6" data-testid="playa-chahue-title">{t.playaChahue.title}</h2>
            <p className="text-[#6B6560] text-lg leading-relaxed mb-4">{t.playaChahue.desc1}</p>
            <p className="text-[#6B6560] leading-relaxed">{t.playaChahue.desc2}</p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {t.playaChahue.stats.map((stat, index) => {
              const Icon = icons[index];
              return (
                <div key={index} className="bg-[#FAF8F5] p-6 text-center" data-testid={`playa-stat-${index}`}>
                  <Icon className="w-6 h-6 text-[#B5613B] mx-auto mb-3" />
                  <span className="block font-heading text-2xl text-[#2D2926] mb-1">{stat.value}</span>
                  <span className="text-xs text-[#6B6560] uppercase tracking-wider">{stat.label}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4">
        {images.map((img, index) => (
          <div key={index} className="relative overflow-hidden group aspect-[4/3]">
            <img src={img.src} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" decoding="async" />
            <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-colors duration-500" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default PlayaChahueSection;
